import styled from 'styled-components';

import { colorCss, fontWeightCss, sizeCss } from 'lib/inquiryStyles';
import { TitleComponentStyles } from 'lib/interfaces/ui-components';
import { fontFamilyCss } from 'verify/lib/utils/font-family';

export default styled('h1').attrs(() => ({
  // Autofocus titles if they exist for a11y
  tabIndex: -1,
}))<{ styles: TitleComponentStyles }>`
  /* TODO [strict-migration] The following is not typed properly; please fix! */
  ${({ styles }) => ({
    // Layout styles
    marginTop: (sizeCss(styles?.margin.base.base?.top as any) as any) ?? 0,
    marginBottom: (sizeCss(styles?.margin.base.base?.bottom as any) as any) ?? 0,
    marginLeft: (sizeCss(styles?.margin.base.base?.left as any) as any) ?? 0,
    marginRight: (sizeCss(styles?.margin.base.base?.right as any) as any) ?? 0,
    // Text styles
    textAlign: styles?.['justify'].base.base as any,
    fontFamily: fontFamilyCss(styles?.['font-family'].base.base) as any,
    fontSize: sizeCss(styles?.['font-size'].base.base) as any,
    fontWeight: fontWeightCss(styles?.['font-weight'].base.base) as any,
    letterSpacing: sizeCss(styles?.['letter-spacing'].base.base) as any,
    lineHeight: sizeCss(styles?.['line-height'].base.base) as any,
    color: colorCss(styles?.['text-color'].base.base) as any,

    a: {
      color: colorCss(styles?.['text-color-highlight'].base.base) as any,
      outlineColor: colorCss(styles?.['text-color-highlight'].base.base) as any,
    },
  })}
`;
